import { useSettings } from '@wu/widget-core';

export function useIconSectionColor() {
  const { colorScheme, sectionColor, accentColor, textColor } = useSettings();

  return (() => {
    switch (colorScheme) {
      case 'light':
        return accentColor || '#111';
      case 'dark':
        return accentColor || '#fff';
      case 'custom':
        return sectionColor || accentColor || textColor;
      default:
        return sectionColor || '#111';
    }
  })();
}
